import React, {useEffect} from 'react';
import {Button, Dialog} from '@betareader/design-system';
import {withTranslation, Trans} from 'react-i18next';
import ChapterFileUpload from './chapterFileUpload';
import ux from '../../../../utils/uxAnalyticsUtil';

export const ChapterUploadModal = ({t, onClose, createBook, open = true}) => {
  useEffect(() => {
    if (open) ux.trackModalView('upload-manuscript');
  }, [open]);

  return (
    <Dialog
      open={open}
      title={t('Upload')}
      onClose={onClose}
      className='br-chapter-upload-dialog'
      actions={<Button variant='secondary' onClick={onClose}>{t('Cancel')}</Button>}
    >
      <ChapterFileUpload
        createBook={createBook}
        onClose={onClose}
        uploadMessage={t('ClickToUploadDoc')}
      />
      {createBook && (
        <em><Trans i18nKey='ImportBooksHelpMsg'>No one will be able to see your manuscript without your approval. Read about <a href='https://betareader.io/help/betareader-format-specification' target='_blank' rel='noopener noreferrer'>importing books</a>.</Trans></em>
      )}
    </Dialog>
  );
};

export default withTranslation()(ChapterUploadModal);
